export default "__VITE_ASSET__10a83224__"